/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';

/* Services */
/* Styles */

/**
 * Renders Json Table UI Component
 * @param {Object} sectionContent - Data from api
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Json Table UI component.
 */
const JsonTableUI = ({ sectionContent, region, lang }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { data } = sectionContent;
  return (
    <MidContainer maxW={'768'}>
      <>
        {sectionContent && sectionContent.data && (
          <Box textAlign="center" pb="50px" pt={{ base: '2rem', md: '50px' }}>
            <Text
              fontSize="24px"
              lineHeight="47px"
              fontFamily="FedraSansStd-A-medium"
              // fontWeight="600"
              color="#000"
            >
              {data.raisedtext}
            </Text>
            <Text
              fontSize="36px"
              lineHeight="36px"
              color="#D04723"
              fontFamily="FedraSansStd-medium"
              mt="1rem"
              mb={{ base: '25px', md: '40px' }}
            >
              <Text
                as="span"
                fontFamily="'FedraSerifDisplay', serif"
                fontWeight="700"
              >
                ₹
              </Text>{' '}
              {Number(data.amtRaised).toLocaleString('en-IN')}
            </Text>
            <Box maxW={455} w="100%" mx="auto">
              {/* <RangeSlider
                max={Number(data.fullAmt)}
                aria-label={['min', 'max']}
                defaultValue={[data.amtRaised]}
                h="11px"
                rounded="full"
                isReadOnly
              >
                <RangeSliderTrack
                  bg="#ffff"
                  border="0.6px solid #C8C8C8"
                  h="11px"
                  rounded="full"
                >
                  <RangeSliderFilledTrack
                    bg="#D04723"
                    border="0.6px solid #D04723"
                  />
                </RangeSliderTrack>
              </RangeSlider> */}
              <Box
                w="100%"
                pos="relative"
                border="0.6px solid #C8C8C8"
                bg="#FFF"
                h="11px"
                rounded="full"
                _before={{
                  content: "''",
                  pos: 'absolute',
                  height: '100%',
                  left: '0',
                  top: '0',
                  width: `${(
                    ([data.amtRaised] / Number(data.fullAmt)) *
                    100
                  ).toFixed(0)}%`,
                  bg: '#D04723',
                  border: '0.6px solid #D04723',
                  rounded: 'full',
                }}
              ></Box>
            </Box>
            {(([data.amtRaised] / Number(data.fullAmt)) * 100).toFixed(0) <
              101 && (
              <Text
                color="#D04723"
                fontSize={{ base: '24px' }}
                lineHeight="29px"
                fontFamily="FedraSansStd-medium"
                mt="20px"
              >
                {(([data.amtRaised] / Number(data.fullAmt)) * 100).toFixed(0)} %
              </Text>
            )}
            <Text
              fontSize="1rem"
              lineHeight="30px"
              fontFamily="FedraSansStd-book"
              color="#000"
            >
              {data.goalReachedText}
            </Text>
            <Text
              fontSize="1rem"
              lineHeight="30px"
              fontFamily="FedraSansStd-medium"
              color="#000"
            >
              {data.goalText}{' '}
              <Text as="span" fontFamily="FedraSansStd-book">
                ₹ {data.fullAmtInWords}
              </Text>
            </Text>
            <Text
              fontSize="1rem"
              lineHeight="30px"
              fontFamily="FedraSansStd-medium"
              color="#000"
              mt="19px"
            >
              {data.noSupporters} {data.supportersText}
            </Text>
          </Box>
        )}
      </>
    </MidContainer>
  );
};

export default JsonTableUI;
